<template>
  <pf-radio
    :label="$t('No')"
    name="domainAction"
    :value="undefined"
    :checked="modelValue === undefined"
    @change="emit('update:modelValue', undefined)"
    ouia-id="wizard-domain-action-none"
  />
  <pf-radio
    :label="$t('Sì, vorrei registrare/trasferire il dominio e attivare i DNS')"
    name="domainAction"
    :value="'registrazione'"
    :checked="modelValue === 'registrazione'"
    @change="$emit('update:modelValue', 'registrazione')"
    ouia-id="wizard-domain-action-registration"
  />
  <p><wizard-price-tag :product="wizard.getProdotto(wizard.codiceProdottoDominio)" /></p>
  <pf-radio
    :label="$t('Vorrei attivare solo il servizio DNS')"
    name="domainAction"
    :value="'dns'"
    :checked="modelValue === 'dns'"
    @change="$emit('update:modelValue', 'dns')"
    ouia-id="wizard-domain-action-dns"
  />
  <p><wizard-price-tag :product="wizard.getProdotto(wizard.codiciProdottiAddon.soloDNS)" /></p>
</template>

<script setup lang="ts">
import { useWizard } from '../composition';
import { type OpzioniDomainAction } from '../wizard.vue';
import WizardPriceTag from '../wizard-price-tag.vue';

defineProps<{
  modelValue: OpzioniDomainAction;
}>();

const emit = defineEmits<{
  (name: 'update:modelValue', v: OpzioniDomainAction): void;
}>();

const wizard = useWizard();

</script>
